import { render, staticRenderFns } from "./MeetingRoomInformation.vue?vue&type=template&id=8b605a1e&scoped=true"
import script from "./MeetingRoomInformation.vue?vue&type=script&lang=js"
export * from "./MeetingRoomInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b605a1e",
  null
  
)

export default component.exports